import { PaymentTransferDetailModel } from '../../models/payments';
import { ProviderConditions } from '../../models/payments-v2';

export enum PaymentProviderDetailsConditions {
  SOURCE_ACCOUNT_REQUIRED_BEFORE_REDIRECT = 'SOURCE_ACCOUNT_REQUIRED_BEFORE_REDIRECT',
  HAS_DOUBLE_REDIRECT = 'HAS_DOUBLE_REDIRECT',
  SOURCE_ACCOUNT_PROVIDED_SKIPS_AIS = 'SOURCE_ACCOUNT_PROVIDED_SKIPS_AIS',
}

export type PaymentProviderDetailsModel = ProviderConditions;

export enum AccountIdentifierType {
  ACCOUNT_IDENTIFIER_TYPE_UNSPECIFIED = 'ACCOUNT_IDENTIFIER_TYPE_UNSPECIFIED',
  SE = 'SE',
  IBAN = 'IBAN',
  SORT_CODE = 'SORT_CODE',
  SE_BG = 'SE_BG',
}

export const PaymentProviderConditions = {
  isSourceAccountRequiredBeforeRedirect: (providerDetails?: PaymentProviderDetailsModel) => {
    if (!providerDetails) {
      return false;
    }

    const paymentsCondition = providerDetails.conditions.find((condtion) => {
      return condtion.rule === 'SOURCE_ACCOUNT_REQUIRED_BEFORE_REDIRECT';
    });

    return (paymentsCondition && paymentsCondition.value) || false;
  },
  isSourceAccountProvidedSkipsAis: (providerDetails?: PaymentProviderDetailsModel) => {
    if (!providerDetails) {
      return false;
    }

    const paymentsCondition = providerDetails.conditions.find((condtion) => {
      return condtion.rule === 'SOURCE_ACCOUNT_PROVIDED_SKIPS_AIS';
    });

    return (paymentsCondition && paymentsCondition.value) || false;
  },
  hasDoubleRedirect: (providerDetails?: PaymentProviderDetailsModel) => {
    if (!providerDetails) {
      return false;
    }

    const paymentsCondition = providerDetails.conditions.find((condtion) => {
      return condtion.rule === 'HAS_DOUBLE_REDIRECT';
    });

    return (paymentsCondition && paymentsCondition.value) || false;
  },
};

export type PaymentTransferResponse = PaymentTransferDetailModel & {
  market: string;
  remittanceInformation: {
    type: string;
    value: string;
  };
  // milliseconds
  created: number;
  // milliseconds
  updated: number;
};

export type PaymentTransfersResponses = {
  paymentRequestCreatedTransfers: PaymentTransferResponse[];
};
